import React from 'react';

import { StyledLink } from './StatusBadge.styles';

type StatusBadgeProps = {
  style?: any;
  title: string;
  route?: string;
  href?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  disabled: boolean;
  className?: string | undefined;
  tabIndex?: number;
  target?: string;
  enabledStatus?: boolean;
  disabledStatus?: boolean;
  notSetStatus?: boolean;
  expiredStatus?: boolean;
  lockedStatus?: boolean;
  yesStatus?: boolean;
  noStatus?: boolean;
  textOnly?: boolean;
  children?: React.ReactNode;
  borderRadiusType?: 'squared' | 'none';
};

const defaultProps = {
  route: '',
  title: '',
  onClick: undefined,
  disabled: false,
  enabledStatus: false,
  disabledStatus: false,
  lockedStatus: false,
  notSetStatus: false,
  expiredStatus: false,
  yesStatus: false,
  noStatus: false,
  textOnly: false,
  tabIndex: '',
};

const StatusBadge = (props: StatusBadgeProps) => {
  const requiredProps: { rel?: string } = {};
  const { ...linkProps } = props;

  if (props.target === '_blank') {
    requiredProps.rel = 'noopener noreferrer';
  }
  return (
    <StyledLink {...linkProps} {...requiredProps} to={props.route} onClick={props.onClick} title={''}>
      {props.title || props.children}
    </StyledLink>
  );
};

StatusBadge.defaultProps = defaultProps;

export { StatusBadge };
